var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"loading":_vm.loading,"width":"350px","color":"#eee","elevation":"0","height":"40px"},on:{"click":_vm.generatePaymentLink}},[_c('img',{attrs:{"src":require("../../../../../../../public/assets/images/flywire_logo.png"),"height":"25px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }